import {Injectable} from '@angular/core';
import {RestService} from "./rest.service";

@Injectable({
  providedIn: 'root'
})
export class PersonalService extends RestService {
  endpoint(): string {
    return "nOperarios";
  }
  param1(): string {
    return "cedula";
  }

  param2(): string {
    return "id_planta";
  }

  param3(): string {
    return "orden_ceco";
  }
}


